import { render, staticRenderFns } from "./consultTip.vue?vue&type=template&id=5e7778f8&scoped=true"
import script from "./consultTip.vue?vue&type=script&lang=js"
export * from "./consultTip.vue?vue&type=script&lang=js"
import style0 from "./consultTip.vue?vue&type=style&index=0&id=5e7778f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7778f8",
  null
  
)

export default component.exports